/**
 * Zentrale Preisdefinitionen für die Marketing Barometer Suite
 *
 * WICHTIG: Alle Preisänderungen NUR hier vornehmen.
 * Diese Datei wird von allen Seiten und Komponenten importiert.
 * Stripe-Preise müssen separat im Stripe-Dashboard aktualisiert werden.
 */

// ─── Einzelpreise der 9 Barometer ───────────────────────────────────────────

export const BAROMETER_PRICES = {
  sensorik: 97,
  lokal: 97,
  geo: 97,
  seo: 97,
  conversion: 97,
  accessibility: 97,
  datenschutz: 97,
  wettbewerb: 97,
  ecommerce: 97,
} as const;

// ─── Paketpreise ─────────────────────────────────────────────────────────────

export const PAKET_PRICES = {
  /** Website-Realitätscheck: SEO + Datenschutz + Accessibility + Lokal */
  website: 297,
  /** Marketing-Realitätscheck: alle 7 Marketing-Barometer */
  marketing: 497,
  /** Komplett-Paket: alle 9 Barometer */
  komplett: 697,
} as const;

// ─── Reguläre Einzelpreissummen (Vergleichswerte für „du sparst X €") ────────

/** Summe aller 9 Einzelpreise ohne Rabatt */
export const KOMPLETT_EINZELSUMME =
  BAROMETER_PRICES.sensorik +
  BAROMETER_PRICES.lokal +
  BAROMETER_PRICES.geo +
  BAROMETER_PRICES.seo +
  BAROMETER_PRICES.conversion +
  BAROMETER_PRICES.accessibility +
  BAROMETER_PRICES.datenschutz +
  BAROMETER_PRICES.wettbewerb +
  BAROMETER_PRICES.ecommerce; // = 873

/** Ersparnis Komplett-Paket */
export const KOMPLETT_ERSPARNIS = KOMPLETT_EINZELSUMME - PAKET_PRICES.komplett; // = 176

/** Einzelsumme Website-Paket (SEO 97 + Datenschutz 97 + Accessibility 97 + Lokal 97) */
export const WEBSITE_EINZELSUMME =
  BAROMETER_PRICES.seo +
  BAROMETER_PRICES.datenschutz +
  BAROMETER_PRICES.accessibility +
  BAROMETER_PRICES.lokal; // = 388

/** Ersparnis Website-Paket */
export const WEBSITE_ERSPARNIS = WEBSITE_EINZELSUMME - PAKET_PRICES.website; // = 91

/** Einzelsumme Marketing-Paket (alle 7 ohne Wettbewerb & E-Commerce) */
export const MARKETING_EINZELSUMME =
  BAROMETER_PRICES.sensorik +
  BAROMETER_PRICES.lokal +
  BAROMETER_PRICES.geo +
  BAROMETER_PRICES.seo +
  BAROMETER_PRICES.conversion +
  BAROMETER_PRICES.accessibility +
  BAROMETER_PRICES.datenschutz; // = 679

/** Ersparnis Marketing-Paket */
export const MARKETING_ERSPARNIS = MARKETING_EINZELSUMME - PAKET_PRICES.marketing; // = 182

// ─── VideoCall-Zusatzoption (Einzelbarometer) ────────────────────────────────

/** Aufpreis für 30-Min-VideoCall zur Ergebnis-Interpretation (Einzelbarometer) */
export const VIDEOCALL_AUFPREIS = 79;

/** Gesamtpreis Einzelbarometer + 30-Min-VideoCall (97 + 79 = 176) */
export const BAROMETER_MIT_VIDEOCALL = 176;

// ─── VideoCall-Zusatzoption (Realitätschecks / Pakete) ───────────────────────

/** Aufpreis für 1h-VideoCall zur Ergebnis-Interpretation (Realitätschecks) */
export const VIDEOCALL_1H_AUFPREIS = 158;

/** Gesamtpreis Website Realitäts-Check™ + 1h-VideoCall (297 + 158 = 455) */
export const WEBSITE_REALITAETSCHECK_MIT_VIDEOCALL = PAKET_PRICES.website + VIDEOCALL_1H_AUFPREIS;

/** Gesamtpreis Marketing Realitäts-Check™ + 1h-VideoCall (497 + 158 = 655) */
export const MARKETING_REALITAETSCHECK_MIT_VIDEOCALL = PAKET_PRICES.marketing + VIDEOCALL_1H_AUFPREIS;

/** Gesamtpreis Komplett-Paket™ + 1h-VideoCall (697 + 158 = 855) */
export const KOMPLETT_PAKET_MIT_VIDEOCALL = PAKET_PRICES.komplett + VIDEOCALL_1H_AUFPREIS;

// ─── Google Ads Produkte ─────────────────────────────────────────────────────

/** Google Ads Potenzialanalyse™ – Einmaliges Einstiegsprodukt */
export const GOOGLE_ADS_POTENZIALANALYSE_PREIS = 297;

// ─── Formatierungshilfe ───────────────────────────────────────────────────────

/** Preis als formatierter String, z.B. formatPrice(97) → "97 €" */
export function formatPrice(price: number): string {
  return `${price} €`;
}
